export var MarketTemplate;
(function (MarketTemplate) {
    MarketTemplate["PointBox"] = "PointBox";
    MarketTemplate["TwoBox"] = "TwoBox";
    MarketTemplate["ThreeBox"] = "ThreeBox";
})(MarketTemplate || (MarketTemplate = {}));
//# sourceMappingURL=MarketTemplate.js.map